// TEMP: metaobject target field has a section ID that doesn't resolve correctly —
// remap it to the correct anchor until the metaobject value is fixed.
const TEMP_TARGET_OVERRIDES = {
  'npdp-accordiontemplate--20912540614821__npdp_hero_collapsable_qNBHGj': '#pdp-anchor-ingredients',
};

const resolveScrollTarget = (value) => {
  if (!value) return null;
  const override = TEMP_TARGET_OVERRIDES[value];
  if (override) return document.querySelector(override);
  if (value.startsWith('.') || value.startsWith('#')) return document.querySelector(value);
  return document.getElementById(value) ?? document.querySelector(`.${value}`) ?? document.querySelector(value);
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-scroll-target]').forEach((tag) => {
    tag.addEventListener('click', () => {
      const targetEl = resolveScrollTarget(tag.dataset.scrollTarget);
      if (!targetEl) return;

      const doScroll = () => {
        const htb = document.querySelector('.header-top-bar');
        const scrollTabs = document.querySelector('[data-scroll-tabs]');
        const tabsVisible = scrollTabs && scrollTabs.dataset.visible === 'true';

        // Base obstacle: scroll-tabs bar on mobile when visible, otherwise header-top-bar.
        const baseObstacle = tabsVisible
          ? scrollTabs.getBoundingClientRect().bottom
          : (htb ? htb.getBoundingClientRect().bottom : 0);

        // The sticky header-desktop collapses mid-scroll (via --header-desktop-offset),
        // shifting the target's absolute position upward. The actual layout shift equals
        // hd.offsetHeight (the element's flow height), not the full navHeight animation
        // range. Subtracting (navHeight - hd.offsetHeight) pre-compensates for exactly
        // the right amount so the section lands flush below the header.
        const navHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--nav-height')
        ) || 0;
        const hd = document.querySelector('.header-desktop');
        const offsetTop = window.scrollY + targetEl.getBoundingClientRect().top - baseObstacle - (navHeight - (hd ? hd.offsetHeight : 0));
        window.scrollTo({ top: Math.max(0, offsetTop), behavior: 'smooth' });
      };

      // If the target section has a collapsed accordion, open it first so the section
      // reaches its full height before we measure scroll position.
      const outerAccordion = targetEl.querySelector('[data-accordion]');
      const trigger = outerAccordion ? outerAccordion.querySelector('[data-accordion-trigger]') : null;
      if (trigger && trigger.getAttribute('aria-expanded') === 'false') {
        trigger.click();
        setTimeout(doScroll, 300); // match accordion CSS transition duration (300ms)
      } else {
        doScroll();
      }
    });
  });
});
